import { AxiosError } from 'axios';

import { autoFinHttpMsg } from './messages.autofin.http';

import { callToast, MessageErrorTypes } from '@creditasmx-utilities/helpers';

export const errorHandler = (err: unknown): void => {
  const parsedErr = err as AxiosError;
  const error = parsedErr.response;
  const status = error?.status || '';
  const code = error?.data?.code || '';

  const httpStatusCode = status.toString();
  const statusCode = code.toString();

  const validateMessage = (code: string, subcode: string): string => {
    if (!autoFinHttpMsg[code]) return autoFinHttpMsg['default'].message;
    else if (!autoFinHttpMsg[code][subcode])
      return autoFinHttpMsg[code]['default'].message;
    else return autoFinHttpMsg[code][subcode].message;
  };

  const msg = validateMessage(httpStatusCode, statusCode);

  callToast(
    `${msg} [${statusCode !== '' ? statusCode : httpStatusCode}]`,
    MessageErrorTypes.error,
  );
};
